<div class="container-fluid">
    <div class="row">
        <div class="col-12" style="text-align: center;">
            <div style="text-align: center;">
                <h2 style="color: red;">Account List Reallocation</h2>
            </div>
            <div style="text-align: center;">
                <p style="font-size: 16px; color:black;"><b style="color: green;">BankName :</b> {{BankName}} | <b style="color: green;">Portfolio Type :</b> {{portfoliotype}}</p>
            </div>
        </div>
    </div>
    
    <div class="row" style="text-align: center; margin:5px;">
        <div class="col-6">
            <div class="row" style="margin-bottom: 5px;">
                <div class="col-6" style="text-align: start;">
                    <label for="designation">Select Designation</label>
                    <select id="designation" [(ngModel)]="designationof" class="form-control" (change)="getdesignationType($event)">
                        <option value="">Choose</option>
                        <option *ngFor="let item of designationList" [value]="item.designation_type">{{item.designation_type}}</option>
                    </select>
                </div>
                <div class="col-6" style="text-align: start;">
                    <label for="assingedto">Select Agent</label>
                    <select id="assingedto" [(ngModel)]="assingedto" (change)="getassignedto($event)" class="form-control">
                        <option value="">Choose</option>
                        <option *ngFor="let item of userList | filterBy: userFilter" [value]="item.email_id">{{item.name}}</option>
                    </select>
                </div>
            </div>
            <div *ngIf="!dataLoaded">
                <p>Please Select an Agent !!!</p>
            </div>

            <div class="table-list" *ngIf="dataLoaded">
                <ag-grid-angular #agGrid 
                    style="width: auto; height: 500px;"
                    class="ag-theme-alpine"
                    [rowData]="myrowData"
                    [rowSelection]="'multiple'"
                    [columnDefs]="columnDefs"
                    [pagination]="true">
                </ag-grid-angular>
            </div>

        </div>
        <div class="col-6">
            <div class="row" style="margin-bottom: 5px;">
                <div class="col-6" style="text-align: start;">
                    <label for="designation">Select Designation</label>
                    <select id="designation" [(ngModel)]="Tdesignationof" class="form-control" (change)="getTdesignationType($event)">
                        <option value="">Choose</option>
                        <option *ngFor="let item of designationList" [value]="item.designation_type">{{item.designation_type}}</option>
                    </select>
                </div>
                <div class="col-6" style="text-align: start;">
                    <label for="assingedto">Select Agent</label>
                    <select id="assingedto" [(ngModel)]="Tassingedto" (change)="getTassignedto($event)" class="form-control">
                        <option value="">Choose</option>
                        <option *ngFor="let item of userList | filterBy: userFilter2" [value]="item.email_id">{{item.name}}</option>
                    </select>
                </div>
            </div>

            <div *ngIf="!dataLoaded2">
                <p>Please Select an Agent !!!</p>
            </div>

            <div class="table-list" *ngIf="dataLoaded2">
                <ag-grid-angular #agGrid2 
                    style="width: auto; height: 500px;"
                    class="ag-theme-alpine"
                    [rowData]="myrowData2"
                    [rowSelection]="'multiple'"
                    [columnDefs]="columnDefs2"
                    [pagination]="true">
                </ag-grid-angular>
            </div>

        </div>
    </div>
</div>
